import React, { memo, useState } from "react";
import styled from "styled-components";
import {
  Confirm,
  IconButton,
  Tooltip,
} from "@workboard/wobo-ui";
// import SelectFilter from "../../SelectFilter"; Post-wave63
import { v4 as uuid } from "uuid";
import { useTranslation } from "react-i18next";

const Export = styled("div").attrs({ className: "MSExcelIcon" })``;

const exportModalClassName = uuid();

const Toolbar = memo(({ className, id, name, teams, titleId, ...props }) => {
  const [showExportModal, setShowExportModal] = useState(false);

  const handleShowExport = () => {
    setShowExportModal(true);
  }

  const handleExport = () => {
    const url = `${wbConfig.baseUrl}/engagementReport/downloadExcelExport?userId=${id}`;
    try {
      window.open(url, "_self");
    } catch(e) {
      console.error('Download Excel file failed', e);
    }
    setShowExportModal(false);
  }
  const { t } = useTranslation()

  return (
    <div className={className} id={titleId}>
      {/* <SelectFilter {...props} /> Post-wave63 */}
      {(teams && teams.totalTeamCount) ? (
        <Tooltip content={t("Export data to Excel")} placement="top-end" arrow>
          <IconButton
            aria-label="export-table"
            data-testid="export"
            onClick={handleShowExport}
          >
            <Export aria-hidden />
          </IconButton>
        </Tooltip>
      ) : (
        ''
      )}

      <Confirm
        title={t("Export Teams Breakdown")}
        className={exportModalClassName}
        submitLabel={t("Export")}
        dismissLabel = {t('Cancel')}
        isOpen={showExportModal}
        onDismiss={() => setShowExportModal(false)}
        onSubmit={() => handleExport()}
      >
        {t('Export Teams under')} {name} {('to Excel')}?
      </Confirm>
    </div>
  );
});

export default styled(Toolbar)`
  align-items: center;
  display: flex;
  height: 40px;

  ${IconButton} {
    margin-left: 16px;
  }
`;
